module.exports = __webpack_public_path__ + "img/woocommerce.531cf50e.png";